import qs from "query-string";
import useSWR, { SWRConfiguration } from "swr";

import { useTokenId } from "../stores/hooks/useTokenId";
import { FetcherResult } from "./fetcher";
import { post } from "./post";
import { ModifiedSWRResponse } from "./useSwrGet";

type UrlParameters = Record<string, string>;

// SWR over a form POST. The cache key has the same shape as useSwrGet's (path,
// parameters, token), so a change of parameters or token refetches and two callers
// with different parameters never share an entry; the parameters travel in the
// request body, not in the URL. Used for the reads that also write on the server
// (getCartContents with markAsQuote, the Xtime appointment URL), see TW-1122.
export const useSwrPost = <Data>(
  path: null | string,
  parameters?: UrlParameters,
  options: SWRConfiguration<FetcherResult<Data>> = {}
): ModifiedSWRResponse<FetcherResult<Data>, Data> => {
  const tokenId = useTokenId();
  const key = path
    ? ["POST", path, qs.stringify({ ...parameters, tokenId })]
    : null;

  const { data, ...rest } = useSWR<FetcherResult<Data>>(
    key,
    () => post<Data>(path as string, parameters),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      ...options,
    }
  );

  return { ...rest, data: data?.payload };
};
